/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * iTopFive API
 * OpenAPI spec version: v1
 */

export type ITopFiveApiV2EndpointsTopFiveGetTopFiveSearchType =
  (typeof ITopFiveApiV2EndpointsTopFiveGetTopFiveSearchType)[keyof typeof ITopFiveApiV2EndpointsTopFiveGetTopFiveSearchType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ITopFiveApiV2EndpointsTopFiveGetTopFiveSearchType = {
  Name: 0,
  TopFive: 1,
} as const;
